import { SliderArrow } from "@components/slider"
import { Heading } from "@components/typography"
import { Container, FlexBox } from "@components/wrapper"
import { useScreenSize } from "@hooks/useScreenSize"
import { Testimony } from "@interfaces/testimony"
import TestimonyServices from "@services/testimony.services"
import clsx from "clsx"
import Image from "next/image"
import { useEffect, useState } from "react"
import Carousel from "react-multi-carousel"

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 30,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: { max: 768, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
}

export const TestimonialSection = () => {
  const { screenWidth } = useScreenSize()

  const [isLoading, setIsLoading] = useState(true)
  const [testimonyList, setTestimonyList] = useState<Testimony[]>([])
  const testimonyServices = new TestimonyServices()

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await testimonyServices.getTestimonyList()
        if (res.isSuccess) {
          const result = res.getValue()
          setTestimonyList(result)
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      } catch (e) {
        setIsLoading(false)
      }
    }

    getData()
  }, [])

  if (!testimonyList.length) {
    return <></>
  }

  return (
    <section className={clsx("relative sm:mt-15 mt-10")}>
      <Container>
        <div className="mx-auto text-center sm:mb-8 mb-6">
          <Heading headingLevel="h3" className="sm:mb-1">
            Testimoni
          </Heading>
          <Heading headingLevel="title" className="mb-2">
            Kata Mereka Tentang <span className="text-green">Corporate Training</span>
          </Heading>
          <Heading headingLevel="subtitle">
            Lihat testimoni dari rangkaian Corporate Training oleh Partner kami
          </Heading>
        </div>

        {screenWidth > 576 ? (
          <div className="relative">
            {/* 
            //@ts-ignore */}
            <Carousel
              responsive={responsive}
              ssr={true} // means to render carousel on server-side.
              arrows={false}
              renderButtonGroupOutside
              containerClass="-mx-[1.15vw]"
              itemClass="py-0 hover:text-inherit px-[1.15vw] w-full"
              customButtonGroup={
                <SliderArrow
                  length={testimonyList.length}
                  displayedSlide={1}
                  leftClassName="top-1/2 w-[42px] h-[42px] -left-[8px]"
                  rightClassName="top-1/2 w-[42px] h-[42px] -right-[8px]"
                />
              }
            >
              {testimonyList.map((value, index) => (
                <TestimonyCard data={value} key={index} />
              ))}
            </Carousel>
          </div>
        ) : (
          <div className="slider-mobile pl-4 !w-[calc(100%+32px)] !mb-0 -mx-4">
            <FlexBox className="w-max gap-3">
              {testimonyList.map((value, index) => (
                <TestimonyCard data={value} key={index} />
              ))}
            </FlexBox>
          </div>
        )}
      </Container>
    </section>
  )
}

interface testimonyCardProps {
  data: Testimony
}

export const TestimonyCard = ({ data }: testimonyCardProps) => {
  return (
    <FlexBox className="sm-only:flex-col sm:w-full w-[75vw]">
      {/* desktop */}
      <div className="relative hidden md:flex sm:w-[45%] w-full">
        <Image
          loading="lazy"
          src={data.testimonyUserPicture}
          alt="corporate image"
          className="object-cover fade_in_left h-[400px] w-full"
          height={400}
          width={1440}
        />
      </div>
      {/* mobile */}
      <div className="h-[47.8vw] relative md:hidden">
        <Image
          loading="lazy"
          src={data.testimonyUserPicture}
          alt="corporate image"
          className="object-cover fade_in_left h-full w-full"
          height={400}
          width={1440}
        />
      </div>

      <FlexBox
        className={clsx("sm:w-[55%] bg-white-f9 sm:pl-[5vw] sm:pr-6", "p-4 w-full")}
        direction="col"
        justify="center"
      >
        <div className={clsx("sm:relative  w-full")}>
          <Image
            loading="lazy"
            src={data.testimonyCompanyPicture}
            alt="corporate image"
            className="sm:h-8 h-[18px] fade_in_left object-contain sm-only:w-fit right-0 "
            height={36}
            width={140}
          />
        </div>
        <p className="text-black-67 sm:my-6 my-4 sm-only:text-xs sm-only:h-[6em]">
          {data.testimony}
        </p>
        <b className="sm:text-sm text-xs">{data.testimonyUsername}</b>
        <p className="text-black-67 sm:text-sm text-xs">{data.testimonyUserAs}</p>
      </FlexBox>
    </FlexBox>
  )
}
